import { render, staticRenderFns } from "./stainHospital.vue?vue&type=template&id=42bfb1ac&scoped=true"
import script from "./stainHospital.vue?vue&type=script&lang=js"
export * from "./stainHospital.vue?vue&type=script&lang=js"
import style0 from "./stainHospital.vue?vue&type=style&index=0&id=42bfb1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfb1ac",
  null
  
)

export default component.exports